<template>
    <b-form-row>
        <b-col v-if="!disabled">
            <label>Customer Assets</label>
            <b-form-select
                :select-size="6"
                id="input-all-assets"
                name="input-all-assets"
                size="sm"
                v-model="markedUnit"
                :options="customerAssets | parseAssets"
            >
            </b-form-select>
        </b-col>
        <b-col cols="2" v-if="!disabled">
            <div>
                <label></label>
                <br /><br />
                <b-button
                    :disabled="!markedUnit"
                    size="sm"
                    variant="primary"
                    block
                    @click="addAsset"
                    >Add</b-button
                >
                <b-button
                    :disabled="!selectedUnit"
                    size="sm"
                    variant="warning"
                    block
                    @click="removeAsset"
                    >Remove</b-button
                >
            </div>
        </b-col>
        <b-col>
            <label>Assigned Assets</label>
            <b-form-select
                id="input-selected-assets"
                :select-size="6"
                name="input-selected-assets"
                size="sm"
                v-model="selectedUnit"
                :options="selectedAssets | parseAssets"
            >
            </b-form-select>
        </b-col>
    </b-form-row>
</template>

<script>
export default {
    name: 'ViewAssets',
    props: ['value', 'customer_id', 'customerAssets', 'disabled'],
    data() {
        return {
            selectedUnit: null,
            markedUnit: null,
            selectedAssets: [],
        }
    },

    filters: {
        parseAssets(assets) {
            return assets.map(x => ({
                value: x.id,
                text: `${x.name}${x.serial_no ? '-' + x.serial_no : ''}`,
            }))
        },
    },

    computed: {},

    watch: {
        /*  value: {
            handler: function (_assets) {
                this.selectedAssets = _assets
            },
            deep: true,
        },*/
    },

    mounted() {
        console.log('assets', this.value)
        const { value: ids, customerAssets } = this

        this.selectedAssets = ids.map(id =>
            customerAssets.find(asset => asset.id == id)
        )
    },

    methods: {
        addAsset() {
            const alreadyExits = !!this.selectedAssets.find(
                x => x.id === this.markedUnit
            )
            if (!alreadyExits) {
                const unit = this.customerAssets.find(
                    x => x.id === this.markedUnit
                )
                this.selectedAssets.push(unit)
            }
            this.markedUnit = null
            this.$emit(
                'input',
                this.selectedAssets.map(x => x.id)
            )
        },
        removeAsset() {
            const idx = this.selectedAssets.findIndex(
                x => x.id === this.selectedUnit
            )
            this.selectedAssets.splice(idx, 1)
            this.selectedUnit = null
            this.$emit(
                'input',
                this.selectedAssets.map(x => x.id)
            )
        },
    },
}
</script>
<style scoped>
.center {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    border: 3px solid green;
}
</style>
